import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import { useParams } from 'react-router'
import { useFeatures } from '../../../hooks/Features/useFeatures'
import Loader from '../../Loader'

function CityView({ city }) {
  const data = [
    { label: 'City Code', data: city.cityCode },
    { label: 'Name', data: city.name },
    { label: 'Region', data: city.region ? city.region.name : '' },
    { label: 'Zone', data: city.zone ? city.zone.name : '' },
    { label: 'State', data: city.state ? city.state.name : '' },
    { label: 'District', data: city.district ? city.district.name : '' },
  ]
  return (
    <Grid container>
      {city ? (
        <Grid item lg={12} container spacing={3}>
          {data.map((item, index) => (
            <Grid item lg={4} key={index}>
              <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                <Typography style={{ fontSize: '16px', fontWeight: 600 }}>{item.label}</Typography>
                <Typography style={{ fontSize: '14px', fontWeight: 400 }}>{item.data}</Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Loader />
      )}
    </Grid>
  )
}

export default CityView
